import { Injectable } from '@angular/core';
import { UrlTree, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UserSettingsService } from '@user-settings/services/user-settings.service';
import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';


/**
 *
 * When applied to a route with a data.product (data.products) property
 * will check the user is licensed for one of the products, if not
 * they will be routed to not-licensed, otherwise the route will continue
 * This is client side only and does not replace the server side license checks
 *
 * If the Product is MojoDashboard and the User is in Preview Mode then they are considered
 * licensed for the route. MojoDashboard product does not route to not-licensed, it just denies
 * the route
 *
 */
@Injectable()
export class ProductLicenseGuard  {

  constructor(
    private readonly router: Router,
    private readonly userSettings: UserSettingsService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree>  {

    const dataProduct = route.data['product'] as MojoWellKnownNames.Product;
    const dataProducts = route.data['products'] as MojoWellKnownNames.Product[];
    const products: MojoWellKnownNames.Product[] = [].concat(dataProduct, dataProducts).filter(a => a != undefined);

    return this.userSettings.getUserSettings().pipe(map(us => {

      if (us.ActualProduct === MojoWellKnownNames.Products.MojoDashboard) {
        return us.IsInPreviewMode;
      }

      if (products.length === 0) {
        console.warn('ProductLicenseGuard applied but no products specified in route data');
      }

      const isAllowed = products.some((val) => us.LicensedProducts.indexOf(val) !== -1);

      if (isAllowed) {
        return true;
      } else {
        return this.router.parseUrl('/not-licensed');
      };

    }));


  }
}
